import { render, staticRenderFns } from "./DeleteContactModal.vue?vue&type=template&id=59dd977c&scoped=true"
import script from "./DeleteContactModal.vue?vue&type=script&lang=js"
export * from "./DeleteContactModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteContactModal.vue?vue&type=style&index=0&id=59dd977c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dd977c",
  null
  
)

export default component.exports